import axios from 'axios';
import md5 from 'md5'
import appConfig from "@/app_config";
import router from "@/router";
import { Toast } from 'vant';


const response_code = {
    SUCCESS: 200, /// 成功
    FAIL: 400, /// 失败
    LOGIN: 401, /// token失效 重新登录
    SERVER_ERROR: 500, /// 服务器异常
}


const network = axios.create({
    // baseURL: process.env.NODE_ENV === 'development' ? '/' : 'https://repaymenth5.naricash.com/app',
    baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASEURL : '/',
    // timeout: 180 * 1000,
    withCredentials: false, // cookie跨域必备
    headers: { /// 请求头，可以存放公共参数
        'Accept': 'application/json,*/*',
        'Content-Type': 'application/json',
        'platform': navigator.userAgent.toUpperCase().indexOf('ANDROID') > -1 ? '1' : '2', //平台类型,1:Android 2:IOS
        'google_referrer': "",    //Google参数
        'loginPlatform': "APP",  //登录平台 APP 和 H5
        'language': "en-US",    //语言，中文:zh-CN 英文：en-US 塔加拉族语：tl-PH
        'appId': appConfig.appId,     //区分马甲包 6 hcash
        'androidId': appConfig.packageName,    //包名
        'version': appConfig.appVersion,    //app版本
        'channel': appConfig.appChannel, // 渠道标识
        'deviceId': '',
        'web-h5': 1,// 网页登陆
    },
});

// 添加请求拦截器
network.interceptors.request.use(function (config) {
    let token = sessionStorage.getItem("token")
    if (token) {
        config.headers.token = token
    }
    config.headers.x_x_path = config.url

    if(config.headers.platform == 2 && config.url == '/appVersion/needUpdate'){
        config.headers.appId = 3
    }
    // 在发送请求之前做些什么
    if (config.params?.rlatedType || config.data?.rlatedType) {
        config.headers['fallPage'] = config.params.rlatedType || config.data.rlatedType
        config.params && delete config.params.rlatedType;
        config.data && delete config.data.rlatedType;
    }
    if (config.isEncryption) {
        const timestamp = new Date().getTime()
        let param = '';
        Object.keys(config.data).sort().forEach(function (key) {
            param += `${key}=${config.data[key]}#`
        });
        param += `appVersion=${appConfig.appVersion}#appId=${appConfig.appId}#timestamp=${timestamp}`
        console.log(param)
        config.headers.timestamp = timestamp
        config.headers.sv = md5(param).toLocaleUpperCase()
    }
    // 处理绑定 参数
    if (config.params?.rlatedType || config.data?.rlatedType) {
        config.headers['fallPage'] = config.params.rlatedType || config.data.rlatedType
        config.params && delete config.params.rlatedType;
        config.data && delete config.data.rlatedType;
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject({
        code: error.code,
        msg: error.message
    });
});

// 添加响应拦截器
network.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    console.log(response)
    if (response.data.code === response_code.SUCCESS) {
        return Promise.resolve(response.data.result);
    }
    if (response.data.code === response_code.LOGIN) {
        sessionStorage.removeItem("token")
        sessionStorage.removeItem("memberId")
        sessionStorage.removeItem("phone")
        router.replace({
            path: 'login'
        })
    }
    let msg = response.data.code === response_code.LOGIN ? 'Login failed, please login again' : response.data.msg
    Toast(msg)
    return Promise.reject({
        code: response.data.code,
        msg: msg
    })
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject({
        code: error.response.status,
        msg: error.response.statusText
    });
});


export default network;